import React from 'react'
import { arrayOf, node, oneOf, oneOfType, shape, string } from 'prop-types'
import classNames from 'classnames'
import Logo from '../logo'
import FooterSection from './footer-section'
import style from './index.scss'
import Paragraph from '../../scentregroup-ui/components/paragraph'

const SiteFooter = ({ className, content, links }) => {
  return (
    <footer
      className={classNames(style.siteFooter, className, {})}
      role="contentinfo"
    >
      <div className={style.container}>
        {content && <FooterSection>{content}</FooterSection>}
        <FooterSection className={style.content}>
          <Logo type={'westfield-red'} className={style.logo} />
          <div className={style.disclaimer}>
            Scentre Group operates its Westfield destinations with a{' '}
            <a href="https://www.scentregroup.com/sustainability">
              responsible business
            </a>{' '}
            mindset, with a focus across the four pillars of community, people, environment
            and economic performance. More information can be found in our{' '}
            <a href="https://www.scentregroup.com/asset/5fKY1xKxf11o4QTNMu5SRh">
              2024 Responsible Business Report
            </a>
            .
          </div>
          {links && (
            <ul className={style.linksList}>
              {links.map(({ label, href }) => (
                <li key={href}>
                  <a href={href} className={style.footerLink}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          )}
          <Paragraph className={style.rightsText}>
            <span>© All rights reserved </span>
            <a
              href="https://www.scentregroup.com"
              className={classNames(style.footerLink, style.rightsTextLink)}
            >
              Scentre Group
            </a>
            <span> {new Date().getFullYear()}</span>
          </Paragraph>
        </FooterSection>
      </div>
      <div className={style.banner}></div>
    </footer>
  )
}

SiteFooter.propTypes = {
  className: string,
  colour: oneOf(['brand', 'seasonal']),
  content: oneOfType([arrayOf(node), node]),
  links: arrayOf(
    shape({
      label: string.isRequired,
      href: string.isRequired,
    })
  ),
}

SiteFooter.defaultProps = {
  className: null,
  colour: 'seasonal',
  links: [],
}

export default SiteFooter
